export const comparisonOperators={
    '$eq':'__eql',
    '$gt':'__gt',
    '$gte':'__gte',
    '$in':'__in',
    '$lt':'__lt',
    '$lte':'__lte',
    '$ne':'__ne',
    '$nin':'__nin',

    '=':'__eql',
    '>':'__gt',
    '>=':'__gte',
    'contains':'__in',
    '<':'__lt',
    '<=':'__lte',
    '!=':'__ne',
    '!contains': '__nin',
    "search": "__reg",
    "range": "__inc",
}

export const logicalOperators={
    '$and':' & ',
    '$or':' | ',

    '&':' & ',
    '|':' | ',
}

export const otherOperators={
    '$not':'$not',
    '!':'$not',
}



